module.exports = __webpack_public_path__ + "img/bolt.f06847a7.svg";